import { Routes, Route, Navigate } from "react-router-dom";
import SettingsPage from "../pages/Settings/SettingsPage";
import LayoutImpressaoPage from "../pages/Settings/LayoutImpressaoPage";
import SitePage from "../pages/Settings/SitePage";

const SettingsRoutes: React.FC = () => {
  return (
    <Routes>
      <Route index element={<SettingsPage />} />
      {/* Layout de impressão da comanda, com preview da bobina. */}
      <Route path="layout-impressao" element={<LayoutImpressaoPage />} />
      {/* Site público do restaurante: endereço, aparência, blocos e unidades. */}
      <Route path="site" element={<SitePage />} />
      <Route path="/*" element={<Navigate to="../" />} />
    </Routes>
  );
};

export default SettingsRoutes;
